import ReducerUtils     from "../../utils/ReducerUtils"
import Actions          from "../../model/constant/actions"

const setStatus = (state, action) => {
  return action.status
}

const Retrieving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_POSSIBLE_WHITE_LABELS] : setStatus
})

export default Retrieving
